import React, { useCallback, useEffect, useState } from 'react'
import { jsDateToString } from 'DatetimeUtils'
import { Form } from 'react-bootstrap'

interface IDateInputProps {
  defaultValue?: string
  onChange: (value: string) => void
  onEntered?: (value: string) => void
}

const DateInput: React.FC<IDateInputProps> = ({ defaultValue, onChange, onEntered }) => {
  const [value, setValue] = useState<string>('')

  const handleChange = useCallback(
    (event) => {
      console.log(event.target.value)
      setValue(event.target.value)
      console.log('change date')
      onChange(event.target.value)

      if (onEntered) onEntered(event.target.value)
    },
    [onChange, onEntered]
  )

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue)
    } else {
      let date = new Date()
      date.setDate(date.getDate() + 1)
      setValue(jsDateToString(date))
    }
  }, [defaultValue])

  return (
    <Form.Control
      value={value}
      type='date'
      style={{ maxWidth: '230px' }}
      onChange={handleChange}
    />
  )
}
export default DateInput
